module.exports = __webpack_public_path__ + "static/img/28.f17f0cfc.png";